<input type="text" [placeholder]="placeholder ?? ''" [formControl]="control" />
<lib-icon
  *ngIf="icon"
  class="w-16 h-16 absolute bottom-4 right-2"
  [name]="icon"
></lib-icon>
